import LoginService from '../../data/LoginService';

const logout = (callback: VoidFunction) => {
  LoginService.signout();
  callback();
};

export default logout;
